import { useGridApiContext, useGridSelector } from '@mui/x-data-grid-premium'
import { GridStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium'

export const gridShowsSkeleton = (state: GridStatePremium): boolean => {
  const pinnedRows = state.rows.additionalRowGroups?.pinnedRows
  const pinnedRowsCount = (pinnedRows?.top?.length ?? 0) + (pinnedRows?.bottom?.length ?? 0)

  return state.rows.loading === true && state.rows.totalRowCount === 0 && pinnedRowsCount === 0
}

export const useGridShowsSkeleton = (): boolean => {
  const apiRef = useGridApiContext()

  return useGridSelector(apiRef, gridShowsSkeleton)
}
